<app-base-side-panel-modal class="h-dvh" [allowFooter]="false">
  <ng-template #header>
    <span class="control-name">{{ control.name }}</span>
  </ng-template>

  <ng-template #content>
    @for (requirement of requirementsToShow; track requirement.id) {
      <div class="flex p-6 flex-col gap-4 rounded-md shadow-sm bg-white border border-solid border-navy-50">
        <div class="text-3xl text-navy-90 flex gap-3 items-center">
          <svg-icon class="control-checkmark-icon h-5.5 w-5.5 svg-blue" [src]="'checkmark'"></svg-icon>

          <span>
            <span class="font-bold">{{ requirement.name }}</span>

            @if (control.show_monitoring && requirement.is_monitored) {
              <app-monitored-label class="ml-3 align-text-top" [isEditing]="false"></app-monitored-label>
            }
          </span>
        </div>

        <div class="text-base text-navy-70 whitespace-pre-line">{{ requirement.description }}</div>
      </div>
    }
  </ng-template>
</app-base-side-panel-modal>
